import styled, { css } from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import {
  DEFAULT_FONT_SIZE_IN_PX,
  TINY_BREAKPOINT_IN_PX,
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
  LAPTOP_BREAKPOINT_IN_PX,
} from '../constants';

const textBase = css`
  display: inline-block;
  color: ${colors.primary.hslGreyDark};
  font-size: ${DEFAULT_FONT_SIZE_IN_PX}px;
  letter-spacing: -0.5px;
  line-height: 30px;
  padding: 0;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 15px;
    letter-spacing: -0.8px;
    line-height: 18px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 14px;
    line-height: 21px;
    letter-spacing: -0.3px;
  }
`;

export const Text = styled.span`
  ${textBase};
`;

export const TextHeavy = styled.span`
  ${textBase};
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.5px;
  line-height: 30px;
  }
`;

export const TextBig = styled.span`
  ${textBase};
  font-size: 18px;
  letter-spacing: -0.3px;
  line-height: 27px;
  margin-bottom: 10px;
`;

export const TextMedium = styled.span`
  ${textBase};
  font-size: 16px;
  letter-spacing: -1px;
  line-height: 20px;
`;

export const ErrorText = styled.span`
  font-size: 16px;
  display: inline-block;
  color: ${colors.primary.hslGreyDark};
  letter-spacing: -0.3px;
  line-height: 24px;
  padding: 0;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 13px;
    line-height: 19px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 10.5px;
    line-height: 16px;
    letter-spacing: -0.2px;
  }
`;

export const TextSmall = styled(Text)`
  font-size: 13px;
  letter-spacing: -0.6px;
  line-height: 15px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 12px;
    letter-spacing: -0.4px;
    line-height: 14px;
  }
`;

export const TextSmallBold = styled(TextSmall)`
  font-weight: 700;
`;

export const Ingress = styled.span`
  ${textBase};

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 18px;
    letter-spacing: -0.3px;
    line-height: 27px;
  }
`;

export const P = styled.p`
  ${textBase};
  display: block;
  margin: 0 0 10px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin: 0 0 20px;
  }
`;

export const A = styled.a`
  color: ${colors.primary.hslBlue};
  font-weight: 350;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${colors.primary.hslBlueDark};
  }
`;

const TitleBase = styled.h2`
  color: ${colors.primary.hslGreyDark};
  font-weight: 500;
  margin: 0;
  padding: 0;
`;

export const H2 = styled(TitleBase)`
  font-size: 36px;
  letter-spacing: -1px;
  line-height: 43px;

  @media screen and (max-width: ${LAPTOP_BREAKPOINT_IN_PX}px) {
    font-size: 30px;
    letter-spacing: -0.7px;
    line-height: 31px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 26px;
    letter-spacing: -0.7px;
    line-height: 31px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 26px;
    letter-spacing: -0.7px;
    line-height: 31px;
  }

  @media screen and (max-width: ${TINY_BREAKPOINT_IN_PX}px) {
    font-size: 22px;
    letter-spacing: -0.7px;
    line-height: 24px;
  }
`;

export const H3 = styled(TitleBase)`
  font-size: 36px;
  letter-spacing: -1px;
  line-height: 43px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 26px;
    letter-spacing: -0.7px;
    line-height: 31px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    font-size: 26px;
    letter-spacing: -0.7px;
    line-height: 31px;
  }
`;

export const H4 = styled(TitleBase)`
  font-size: 30px;
  letter-spacing: -0.8px;
  line-height: 36px;
  margin-bottom: 10px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    font-size: 16px;
    letter-spacing: -0.3px;
    line-height: 24px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  @media screen and (max-width: ${TINY_BREAKPOINT_IN_PX}px) {
    line-height: 22px;
  }
`;
